<p-card class="flex flex-col w-full h-full">
  <div class="flex flex-col w-full h-full p-[1.25rem]">
    <div class="w-full">{{getCurrentMonthLong().toLocaleUpperCase()}}</div>
    <div class="justify-center w-full mt-[0.625rem]">
      <table>
        <thead>
          @for (weekday of getWeekDaysShort(); track weekday) {
            <th>{{weekday}}</th>
          }
        </thead>
        <tbody>
          @for (week of [1,2,3,4,5,6]; track week) {
            <tr>
              @for (day of [1,2,3,4,5,6,7]; track day) {
                <td class="text-center p-[0.3125rem]"
                  [ngClass]="{'notInMonth':!isDayInMonth(week,day)}">
                  @if (isDayInMonth(week,day)) {
                    <p-badge [value]="getDayOfMonth(week,day).day" badgeSize="xlarge"
                    styleClass="p-badge-circle" [severity]="getSeverityForDay(week,day)"></p-badge>
                  }
                  @if (!isDayInMonth(week,day)) {
                    {{getDayOfMonth(week,day).day}}
                  }
                </td>
              }
            </tr>
          }
        </tbody>
      </table>
    </div>
    <div class="flex flex-col justify-start w-full mt-[1.25rem] flex-grow">
      <div class="flex flex-row w-full items-center">
        <span class="mr-[1.25rem]"><p-badge badgeSize="xlarge" severity="info" /></span>{{"Calendar.Today"|translate}}
      </div>
      <div class="flex flex-row w-full items-center">
        <span class="mr-[1.25rem]"><p-badge badgeSize="xlarge" severity="warn" /></span>{{"Calendar.FullyBooked"|translate}}
      </div>
      <div class="flex flex-row w-full items-center">
        <span class="mr-[1.25rem]"><p-badge badgeSize="xlarge" severity="success" /></span>{{"Calendar.OpenTimeSlot"|translate}}
      </div>
      <div class="flex flex-row w-full items-center">
        <span class="mr-[1.25rem]"><p-badge badgeSize="xlarge" severity="secondary" /></span>{{"Calendar.Absent"|translate}}
      </div>
    </div>
    <div class="self-center mt-[1.25rem]">
      <p-button size="large" label="{{'OpenCalendar'|translate}}" routerLink="../calendar" />
    </div>
  </div>
</p-card>
